// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"wl x2","ribbon":"wm x_","title":"wn x4","year":"wo x5","genres":"wp x-","duration":"wq","buttonWrapper":"wr x6","button":"ws x7","price":"wt","upperParts":"wu"};